if (!customElements.get('sp-promotion-deal')) {
  customElements.define(
    'sp-promotion-deal',
    class SPPromotionDeal extends HTMLElement {
      constructor() {
        super();

        this.button = this.querySelector('[data-sp-promo-add]');
        this.message = this.querySelector('[data-sp-promo-message]');

        this.button?.addEventListener('click', this.addDeal.bind(this));
      }

      async addDeal() {
        if (
          !this.button ||
          this.button.disabled ||
          this.button.getAttribute('aria-disabled') === 'true'
        ) {
          return;
        }

        const buyVariantId = Number(this.dataset.buyVariantId);
        const freeVariantId = Number(this.dataset.freeVariantId);

        if (!buyVariantId || !freeVariantId) {
          this.showError('This deal is not configured yet.');
          return;
        }

        const cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');

        const sections =
          cart?.getSectionsToRender?.().map((section) => section.id) || [];

        const originalText = this.button.textContent;

        this.button.disabled = true;
        this.button.classList.add('is-loading');
        this.button.textContent = this.dataset.loadingText || 'Adding deal…';
        this.showError('');

        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            credentials: 'same-origin',
            body: JSON.stringify({
              items: [
                {
                  id: buyVariantId,
                  quantity: 1,
                  properties: {
                    '_SP Promotion':
                      this.dataset.promotionName || 'SP Promotion',
                  },
                },
                {
                  id: freeVariantId,
                  quantity: 1,
                  properties: {
                    '_SP Promotion':
                      this.dataset.promotionName || 'SP Promotion',
                    '_Promotion Item': 'Free item',
                  },
                },
              ],
              sections: sections,
              sections_url: window.location.pathname,
            }),
          });

          const responseText = await response.text();

          let state;

          try {
            state = JSON.parse(responseText);
          } catch (_error) {
            throw new Error(
              'Shopify returned an invalid cart response. Please refresh the page and try again.'
            );
          }

          if (!response.ok || state.status) {
            throw new Error(
              state.description ||
                state.message ||
                'The deal could not be added.'
            );
          }

          if (cart?.renderContents && state.sections) {
            cart.setActiveElement?.(this.button);
            cart.renderContents(state);
          } else {
            window.location.href = window.routes?.cart_url || '/cart';
          }
        } catch (error) {
          this.showError(
            error.message ||
              'The deal could not be added. Please try again.'
          );
        } finally {
          this.button.disabled = false;
          this.button.classList.remove('is-loading');
          this.button.textContent = originalText;
        }
      }

      showError(message) {
        if (this.message) {
          this.message.textContent = message;
        }
      }
    }
  );
}
if (!customElements.get('sp-promotion-product')) {
  customElements.define(
    'sp-promotion-product',
    class SPPromotionProduct extends HTMLElement {
      constructor() {
        super();

        this.button = this.querySelector('[data-sp-discount-add]');
        this.message = this.querySelector('[data-sp-discount-message]');

        this.button?.addEventListener(
          'click',
          this.addProduct.bind(this)
        );
      }

      async addProduct() {
        if (
          !this.button ||
          this.button.disabled ||
          this.button.getAttribute('aria-disabled') === 'true'
        ) {
          return;
        }

        const variantId = Number(this.dataset.variantId);

        if (!variantId) {
          this.showError('This product is not configured yet.');
          return;
        }

        const cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');

        const sections =
          cart?.getSectionsToRender?.().map((section) => section.id) || [];

        const originalText = this.button.textContent.trim();

        this.button.disabled = true;
        this.button.classList.add('is-loading');
        this.button.textContent = 'Adding…';
        this.showError('');

        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            credentials: 'same-origin',
            body: JSON.stringify({
              items: [
                {
                  id: variantId,
                  quantity: 1,
                  properties: {
                    '_SP Promotion': 'Discount Promotion',
                  },
                },
              ],
              sections: sections,
              sections_url: window.location.pathname,
            }),
          });

          const responseText = await response.text();

          let state;

          try {
            state = JSON.parse(responseText);
          } catch (_error) {
            throw new Error(
              'Shopify returned an invalid cart response. Please refresh and try again.'
            );
          }

          if (!response.ok || state.status) {
            throw new Error(
              state.description ||
                state.message ||
                'The product could not be added.'
            );
          }

          if (cart?.renderContents && state.sections) {
            cart.setActiveElement?.(this.button);
            cart.renderContents(state);
          } else {
            window.location.href =
              window.routes?.cart_url || '/cart';
          }
        } catch (error) {
          this.showError(
            error.message ||
              'The product could not be added. Please try again.'
          );
        } finally {
          this.button.disabled = false;
          this.button.classList.remove('is-loading');
          this.button.textContent = originalText;
        }
      }

      showError(message) {
        if (this.message) {
          this.message.textContent = message;
        }
      }
    }
  );
}
if (!customElements.get('sp-promotions-slider')) {
  customElements.define(
    'sp-promotions-slider',
    class SPPromotionsSlider extends HTMLElement {
      constructor() {
        super();

        this.viewport = this.querySelector('[data-sp-promo-viewport]');
        this.track = this.querySelector('[data-sp-promo-track]');
        this.previousButton = this.querySelector('[data-sp-promo-prev]');
        this.nextButton = this.querySelector('[data-sp-promo-next]');
        this.controls = this.querySelector(
          '.sp-promotions__slider-controls'
        );

        if (!this.viewport || !this.track) return;

        this.previousButton?.addEventListener('click', () => {
          this.move(-1);
        });

        this.nextButton?.addEventListener('click', () => {
          this.move(1);
        });

        this.viewport.addEventListener(
          'scroll',
          () => this.updateControls(),
          { passive: true }
        );

        this.viewport.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.move(-1);
          }

          if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.move(1);
          }
        });

        this.resizeObserver = new ResizeObserver(() => {
          this.updateControls();
        });

        this.resizeObserver.observe(this.viewport);
        this.resizeObserver.observe(this.track);

        requestAnimationFrame(() => this.updateControls());
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
      }

      getScrollStep() {
        const card = this.track.querySelector('.sp-promo-card');

        if (!card) return this.viewport.clientWidth;

        const trackStyles = window.getComputedStyle(this.track);
        const gap = parseFloat(trackStyles.columnGap) || 0;

        return card.getBoundingClientRect().width + gap;
      }

      move(direction) {
        this.viewport.scrollBy({
          left: this.getScrollStep() * direction,
          behavior: 'smooth',
        });
      }

      updateControls() {
        const maximumScroll =
          this.viewport.scrollWidth - this.viewport.clientWidth;

        const hasOverflow = maximumScroll > 2;
        const atBeginning = this.viewport.scrollLeft <= 2;
        const atEnd =
          this.viewport.scrollLeft >= maximumScroll - 2;

        if (this.controls) {
          this.controls.hidden = !hasOverflow;
        }

        if (this.previousButton) {
          this.previousButton.disabled = !hasOverflow || atBeginning;
          this.previousButton.setAttribute(
            'aria-disabled',
            String(!hasOverflow || atBeginning)
          );
        }

        if (this.nextButton) {
          this.nextButton.disabled = !hasOverflow || atEnd;
          this.nextButton.setAttribute(
            'aria-disabled',
            String(!hasOverflow || atEnd)
          );
        }
      }
    }
  );
}